import { action } from 'satcheljs';
import { InboxReminder } from 'owa-graph-schema';
import type EmailReminderEntrySource from '../store/schema/EmailReminderEntrySource';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export const appendToInboxReminders = action(
    'appendToInboxReminders',
    (
        inboxReminderToAppend: InboxReminder,
        event: CalendarEvent,
        entrySource: EmailReminderEntrySource,
        viewStateId: string | null
    ) => ({
        inboxReminderToAppend,
        event,
        entrySource,
        viewStateId,
    })
);

export const appendToInboxRemindersStoreUpdate = action(
    'appendToInboxReminders',
    (inboxReminderToAppend: InboxReminder, event: CalendarEvent) => ({
        inboxReminderToAppend,
        event,
    })
);

export const removeInboxReminder = action(
    'removeInboxReminder',
    (
        idToRemove: string,
        event: CalendarEvent,
        entrySource: EmailReminderEntrySource,
        viewStateId: string | null
    ) => ({
        idToRemove,
        event,
        entrySource,
        viewStateId,
    })
);

export const removeInboxReminderStoreUpdate = action(
    'removeInboxReminderStoreUpdate',
    (idToRemove: string, event: CalendarEvent) => ({
        idToRemove,
        event,
    })
);

export const replaceMatchingReminder = action(
    'replaceMatchingReminder',
    (
        reminder: InboxReminder,
        event: CalendarEvent,
        entrySource: EmailReminderEntrySource,
        viewStateId: string | null
    ) => ({
        reminder,
        event,
        entrySource,
        viewStateId,
    })
);

export const replaceMatchingReminderStoreUpdate = action(
    'removeInboxReminderStoreUpdate',
    (reminder: InboxReminder, event: CalendarEvent) => ({
        reminder,
        event,
    })
);

export const convertToServiceInboxReminders = action(
    'convertToServiceInboxReminders',
    (newReminderIds: string[], inboxReminders: InboxReminder[]) => ({
        newReminderIds,
        inboxReminders,
    })
);
